{
  "name": "eva-dora",
  "version": "1.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration=production",
    "test": "ng test"
  },
  "private": true,
  "engines": {
    "node": "24.x"
  },
  "dependencies": {
    "@angular/animations": "^22.2.4",
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/material": "^22.2.5",
    "@angular/platform-browser": "^22.2.4",
    "@angular/platform-browser-dynamic": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@microsoft/signalr": "^6.0.25",
    "@sentry/angular": "^11.10.0",
    "@springtree/eva-config-picker": "^1.18.1",
    "@springtree/eva-sdk-redux": "^5.24.0",
    "@stackblitz/sdk": "^1.3.0",
    "dexie": "^3.2.2",
    "fuse.js": "3.2.1",
    "highlight.js": "^11.12.0",
    "json-formatter-js": "^2.2.1",
    "lodash-es": "^4.18.1",
    "marked": "^18.1.3",
    "marked-highlight": "^2.2.4",
    "monaco-editor": "^0.21.2",
    "oidc-client-ts": "^3.5.0",
    "redux": "^4.0.5",
    "rxjs": "~7.8.2",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.4",
    "@angular/language-service": "^22.2.4",
    "@types/lodash-es": "^4.14.149",
    "@types/node": "^24.19.2",
    "jsdom": "^30.1.3",
    "typescript": "~6.0.3",
    "vitest": "^5.0.0"
  },
  "overrides": {
    "@grpc/grpc-js": "^1.13.6"
  }
}
